import { Timestamp } from 'firebase/firestore';



export class Offer {

  public id: string | undefined;

  public itemId: string | undefined = undefined;

  public price: number = 0;

  public offerAmount: number = 0;

  public created: Timestamp | undefined = undefined;

  public state: string = 'pending';

  public emitterId: string | undefined = undefined;

  public emitterName: string | undefined = undefined;

  public buyerUid?: string;

  public buyerName?: string;

  public sellerUid?: string;

  public receiverId: string | undefined = undefined;

  public receiverName: string = "";

  public thumbnailUrl: string | undefined = undefined;

  public itemName: string | undefined = undefined;

  public paymentRequest!: google.payments.api.PaymentDataRequest;

  public carrier?: string;

  public serviceType?: string;

  public trackingNumber?: string;

  public shippingTier?: string;

  public shippoLabelUrl?: string;

  public shippingFee?: number;

  public totalPaid?: number;

  public commissionRate?: number;

  public commissionFee?: number;

  public sellerNet?: number;

  public tierName?: string;

  public paymentStatus?: string;

  public dispatchStatus?: string;

  public shippingAddress?: {

    name?: string;

    street?: string;

    city?: string;

    postcode?: string;

    country?: string;

  };

  public currency?: string = 'GBP';

  public buyerReviewed?: boolean = false;

  public buyerRating?: number;

  public sellerReviewed?: boolean = false;

  public sellerRating?: number;

  public receptionStatus?: 'pending' | 'confirmed';

  public receivedAt?: any;

  public dealClosed?: boolean;
  public refundStatus?: string;
  public cancellationReason?: string;
  public cancellationInitiator?: string;



  constructor() {}

}

